<div id="graphclassesdiv" #graphclassesdiv class="graph-classes" [style.height.px]="height">
</div>